// Core enums for card representation

export enum Suit {
  SPADES = '♠',
  HEARTS = '♥',
  DIAMONDS = '♦',
  CLUBS = '♣'
}

export enum Rank {
  ACE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  JACK = 11,
  QUEEN = 12,
  KING = 13
}

export enum Color {
  RED = 'red',
  BLACK = 'black'
}

export enum PileType {
  STOCK = 'stock',
  WASTE = 'waste',
  FOUNDATION = 'foundation',
  TABLEAU = 'tableau'
}

export enum DrawMode {
  ONE_CARD = 1,
  THREE_CARD = 3
}

// Core data structures

export interface CardData {
  suit: Suit;
  rank: Rank;
  color: Color;
  isFaceUp: boolean;
  id: string; // Unique identifier (e.g., "H7", "SA")
}

export interface Move {
  fromPile: PileType;
  fromIndex: number; // Index in the pile array (for tableau/foundation)
  toPile: PileType;
  toIndex: number;
  cards: CardData[]; // Cards that were moved
  flippedCard?: string; // ID of card that was auto-flipped (if any)
  timestamp: number;
}

export interface GameStateData {
  stock: CardData[];
  waste: CardData[];
  foundations: CardData[][]; // 4 foundation piles (one per suit)
  tableau: CardData[][]; // 7 tableau piles
  drawMode: DrawMode;
  moveCount: number;
  startTime: number;
  moves: Move[]; // Move history for undo/redo
}
